import * as actions from '../actions/';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import ListingDetail from '../components/listing-detail';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    config: state.store.config,
    listing: state.store.listing,
    defaultOptions: state.store.defaultOptions
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ListingDetail);



// WEBPACK FOOTER //
// ./src/containers/listing-detail.js